import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Typography } from "@mui/material";
import * as React from "react";

export const MprcCardCourseIcon: React.FC<{ icon: IconProp; }> = (props) => {
    return <FontAwesomeIcon icon={props.icon} fontSize={40} fixedWidth />;
};

interface IProps {
    icon: IconProp;
    title?: string;
    message?: string | React.ReactNode;
}

export const MprcCardCourseMessageIcon: React.FC<IProps> = (props) => {

    const { title, message, icon } = props;

    return (
        <Grid container spacing={1} alignItems="flex-start">
            <Grid>
                <MprcCardCourseIcon icon={icon} />
            </Grid>
            <Grid>
                {
                    title &&
                    <Typography variant="subtitle1" component="p" sx={{ textTransform: 'uppercase' }}>
                        {title}
                    </Typography>
                }
                {
                    message && (
                        typeof message == "string"
                            ?
                            <Typography variant="caption" component="p">
                                {message}
                            </Typography>
                            :
                            message
                    )
                }
            </Grid>
        </Grid>
    );
};